import apiClient from "@/services/ApiClient";

export default {
  name: "auth",
  login: credentials => apiClient.post("/auth/login", credentials),
};
